// extracted by mini-css-extract-plugin
module.exports = {"root":"EventMassEmailMaintenanceTable_root__3HTEg","dialog":"EventMassEmailMaintenanceTable_dialog__18gpq","submitButton":"EventMassEmailMaintenanceTable_submitButton__3u2e_"};